// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Qt0v","location":"Header_location__3bgNB"};